@use "../../styles/breakpoint.module.scss" as *;

.l2ListBase {
    // Design has columns being centered which doesn't work with grid, so
    // let's do flexbox instead

    // On desktop, we're treating each item as though it's in a layout that
    // shows five items, even if only two or three items are showing...
    // UNLESS there are more than five items.

    // Have to do some math to account for gap widths.
    // --items is set in NavPopover.tsx
    --items-per-row: max(var(--items), 5);
    --gutters: calc(var(--items-per-row) - 1);
    --gutter-width: var(--labui-grid-gap);
    --gutter-space: calc(var(--gutter-width) * var(--gutters));
    --width: calc((100% - var(--gutter-space)) / var(--items-per-row));

    composes: listReset from "../../styles/composable/utility.module.css";
    display: flex;
    justify-content: center;
    gap: var(--labui-grid-gap);
    width: 100%;

    > li {
        width: var(--width);

        > a {
            width: 100%;
        }
    }
}

.l2List {
    composes: l2ListBase;
}

.l2ListMobile {
    --items-per-row: 2;

    composes: l2ListBase;
    flex-flow: row wrap;
    justify-content: flex-start;

    @media ($below-mobile) {
        // if there are 5 or more items
        &:has(> li:nth-child(5)) {
            --items-per-row: 3;
        }
    }

    @media ($above-mobile) {
        --items-per-row: 3;
    }

    @media ($above-tablet) {
        --items-per-row: 4;
    }
}

.popoverBase {
    left: 0;
    width: 100%;
    z-index: 1;
}

.popover {
    composes: popoverBase;
    position: fixed;
    top: var(--header-height);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacer-32);
    padding-block: var(--spacer-64) var(--spacer-40);
    padding-inline: var(--spacer-48);
    border-top: 1px solid var(--pale-navy);
}

.mobilePopover {
    composes: popoverBase;
    position: relative;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: first baseline;
    gap: var(--spacer-32);
}

.underlay {
    position: fixed;
    inset: var(--header-height) 0 0;
    background-color: var(--dark-overlay-40);
    z-index: 0;
}

.itemPicture {
    position: relative;
    display: block;
    width: 100%;
    margin-bottom: var(--spacer-12);
    aspect-ratio: 1;

    > :is(img, video, iframe) {
        position: absolute;
        inset: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}

.itemTitle {
    font: var(--font-h-18);
    letter-spacing: -0.01em;
    text-align: center;

    @media ($below-mobile) {
        text-align: left;
    }

    @media ($below-tiny) {
        font-size: 14px;
    }
}
